export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/@apollo/client/cache/core/types/Cache.js
// module id = 1984
// module chunks = 69